module.exports = __webpack_public_path__ + "img/vmd.80078a9f.svg";